import {
    getProductSalePrice,
    getProductListPrice,
    productIsOnSale
} from 'services/cartUtils';

export const FacebookPixelService = angular
    .module('checkout.services.facebookPixelService', [])
    .service('facebookPixelService', (
        $window
    ) => {
        function getItemPrice(product) {
            const itemIsOnSale = productIsOnSale(product);
            return itemIsOnSale
                ? getProductSalePrice(product.pricing.salePrice)
                : getProductListPrice(product);
        }

        function extractPayloadContentFromCartItem(cartItem) {
            if (cartItem.product) {
                return {
                    id: cartItem.product.sku,
                    quantity: cartItem.quantity,
                    item_price: getItemPrice(cartItem.product)
                };
            }

            return {
                id: cartItem.sku,
                quantity: cartItem.quantity,
                item_price: cartItem.price.amount / 100
            };
        }

        function getContents(cartItems) {
            return cartItems.map(extractPayloadContentFromCartItem);
        }

        function calculateTotalQuantity(sum, cartItem) {
            return sum += cartItem.quantity;
        }

        function getTotalItems(cartItems) {
            return cartItems.reduce(calculateTotalQuantity, 0);
        }

        function getPayload(cart, cartGrandTotal) {
            const value = cartGrandTotal !== undefined && cartGrandTotal !== null ?
                cartGrandTotal : cart.grandTotal;
            return {
                value,
                currency: 'USD',
                content_type: 'product',
                contents: getContents(cart.items),
                num_items: getTotalItems(cart.items)
            };
        }

        function trackPurchaseEvent(cart) {
            if ($window.fbq) {
                let params = {};
                if (cart) {
                    params = getPayload(cart);
                }
                $window.fbq('track', 'Purchase', params);
            }
        }

        function trackInitiateCheckoutEvent(cart, cartGrandTotal) {
            if ($window.fbq) {
                let params = {};
                if (cart) {
                    params = getPayload(cart, cartGrandTotal);
                }
                $window.fbq('track', 'InitiateCheckout', params);
            }
        }

        return {
            trackInitiateCheckoutEvent,
            trackPurchaseEvent
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/facebookPixel.service.js